"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostSupplyChangeElements = void 0;
const Base_1 = require("./Base");
exports.PostSupplyChangeElements = {
    url: Base_1.URL_BASE + "/SupplyChangeElements",
    method: "POST",
    secure: true
};
//# sourceMappingURL=PostSupplyChangeElements.js.map